import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateProductPurchaseMutation } from "../graphql/mutations";
import type {
  UpdateProductPurchaseMutationType,
  UpdateProductPurchaseMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateProductPurchaseMutation = (
  options?: MutationHookOptions<
    UpdateProductPurchaseMutationType,
    UpdateProductPurchaseMutationVariablesType
  >
) => {
  return useMutation<
    UpdateProductPurchaseMutationType,
    UpdateProductPurchaseMutationVariablesType
  >(UpdateProductPurchaseMutation, options);
};
